module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-14.95cbe465.png";